import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { directControlButtonsConfig } from '@app/my-zone/config/direct-control-buttons.config';
import { DirectControlButtonActionEnum } from '@app/my-zone/enums/direct-control-button-action.enum';
import { DirectControlButtonInterface } from '@app/my-zone/interfaces/direct-control-button.interface';
import { DirectControlService } from '@app/my-zone/services/direct-control.service';
import { WucBalloonComponent, WucButtonComponent, WucDropTriggerComponent } from '@inshared/website-ui-components';
import { PurchasedProductInterface } from 'outshared-lib';

@Component({
    selector: 'ins-direct-control-buttons',
    templateUrl: 'direct-control-buttons.component.html',
})
export class DirectControlButtonsComponent implements OnInit {
    @Input() public purchasedProduct: PurchasedProductInterface;

    public directControlButtons: DirectControlButtonInterface[];

    @ViewChild(WucDropTriggerComponent, { static: false }) public dropTrigger: WucDropTriggerComponent;
    @ViewChild(WucBalloonComponent, { static: false }) public balloon: WucBalloonComponent;
    @ViewChild(WucButtonComponent, { static: false }) public button: WucButtonComponent;

    constructor(private directControlService: DirectControlService) {}

    public get isOpen(): boolean {
        return this.dropTrigger?.isDropVisible;
    }

    public ngOnInit(): void {
        this.directControlButtons = this.directControlService.initConfig(
            directControlButtonsConfig,
            this.purchasedProduct
        );
    }

    public onClick(directControlButton: DirectControlButtonInterface): void {
        switch (directControlButton.action) {
            case DirectControlButtonActionEnum.Link: {
                this.directControlService.link(directControlButton.actionLink);
                break;
            }
            case DirectControlButtonActionEnum.RouterLink: {
                this.directControlService.routerLink(directControlButton.actionRouterLink);
                break;
            }
            case DirectControlButtonActionEnum.TogglePanel: {
                this.directControlService.togglePanel(directControlButton.actionPanel, this.purchasedProduct);
                break;
            }
            case DirectControlButtonActionEnum.Modal: {
                this.directControlService.modal(directControlButton.actionModal, this.purchasedProduct);
                break;
            }
            case DirectControlButtonActionEnum.ReplaceCar: {
                this.directControlService.replaceCar(this.purchasedProduct);
                break;
            }
            case DirectControlButtonActionEnum.ReplaceMotorcycle: {
                this.directControlService.replaceMotorcycle(this.purchasedProduct);
                break;
            }
        }
        this.dropTrigger.hide();
    }
}
